import { render, staticRenderFns } from "./SelectBoxAndAddButton.vue?vue&type=template&id=61561d56&scoped=true&"
import script from "./SelectBoxAndAddButton.vue?vue&type=script&lang=js&"
export * from "./SelectBoxAndAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61561d56",
  null
  
)

export default component.exports